import { Injectable } from '@angular/core';

import { Api } from '../api/api';
import { IEmailItem } from '../types';
@Injectable({
  providedIn: 'root'
})
export class NotifyService {

    constructor(private readonly api: Api) {

    }

    public async notifyByEmail(emailItem: IEmailItem) {

        await this.api.http2.post('api/notify/email', emailItem);
    }
}
